
enum SubmitSelectivePricingInputAdjustmentType {
	PERCENTAGE = 'PERCENTAGE',
	AMOUNT = 'AMOUNT',
}

export default SubmitSelectivePricingInputAdjustmentType
